import React, { useState } from 'react';
import AddWidgetForm from '../components/AddWidgetForm';
import WidgetList from '../components/WidgetList';
import AdminLayout from '../components/AdminLayout';

function WidgetManagerPage() {
  const [refresh, setRefresh] = useState(false);

  return (
    <AdminLayout>
      <h5 className="mb-3">🧩 AI Chat Widgets</h5>
      <AddWidgetForm onWidgetCreated={() => setRefresh(!refresh)} />
      <WidgetList key={refresh} />
    </AdminLayout>
  );
}

export default WidgetManagerPage;
